import { FC } from 'react'
import { ProviderWithChart } from 'assets'
export const PediatricCenterCriteria: FC = () => {
  return (
    <div className="bg-white rounded-lg shadow-lg overflow-hidden">
      <div className="aspect-w-16 aspect-h-9 h-80 max-h-80">
        <img
          src={ProviderWithChart}
          alt="Doctor with chart"
          className="object-cover w-full h-full"
        />
      </div>
      <div className="p-6">
        <h3 className="text-2xl font-serif text-[#3C2416] mb-4">
          Pediatric Center Criteria
        </h3>
        <div className="prose-text">
          <p className="text-[#3C2416] mb-6">
            The elements needed to become a member of NASCC for a Sickle Cell
            center that treats children are as follows:
          </p>

          <div className="mb-6">
            <div className="font-bold text-[#3C2416] mb-2">
              Essential personnel requirements:
            </div>
            <ul className="ml-6 space-y-2 list-disc">
              <li className="text-[#3C2416]">
                Sickle Cell Specialist (physician)
              </li>
              <li className="text-[#3C2416]">
                Case Manager/Patient Navigator (or someone who fills this role)
              </li>
              <li className="text-[#3C2416]">Social Worker(s)</li>
              <li className="text-[#3C2416]">
                Pediatric Hematology Team Managing Inpatient Care
              </li>
              <li className="text-[#3C2416]">
                Outpatient Nursing Staff with SCD Expertise
              </li>
            </ul>
          </div>

          <div className="mb-6">
            <div className="font-bold text-[#3C2416] mb-2">
              Essential protocols and treatments available:
            </div>
            <ul className="ml-6 space-y-2 list-disc">
              <li className="text-[#3C2416]">
                Written procedures for acute/chronic management
              </li>
              <li className="text-[#3C2416]">
                Protocols for newborn screening follow-up
              </li>
              <li className="text-[#3C2416]">
                Protocols for Emergency Department care
              </li>
              <li className="text-[#3C2416]">
                Defined transition plan from pediatric to adult care
              </li>
              <li className="text-[#3C2416]">
                Standardized order sets in EMR for pain admission
              </li>
              <li className="text-[#3C2416]">
                Formal process for patient/family input
              </li>
              <li className="text-[#3C2416]">
                Erythrocytopheresis for acute and chronic treatments
              </li>
            </ul>
          </div>

          <div className="mb-6">
            <div className="font-bold text-[#3C2416] mb-2">
              Essential diagnostic and treatment requirements:
            </div>
            <ul className="ml-6 space-y-2 list-disc">
              <li className="text-[#3C2416]">
                On-site transcranial Doppler ultrasonography
              </li>
              <li className="text-[#3C2416]">
                Iron overload measurement by MRI
              </li>
              <li className="text-[#3C2416]">Compound hydroxyurea</li>
              <li className="text-[#3C2416]">
                Annual individualized care plan
              </li>
            </ul>
          </div>

          <div>
            <div className="font-bold text-[#3C2416] mb-2">
              Required Links and Partnerships:
            </div>
            <ul className="ml-6 space-y-2 list-disc">
              <li className="text-[#3C2416]">
                Timely access to specialist services including family planning
              </li>
              <li className="text-[#3C2416]">Mental health provider</li>
              <li className="text-[#3C2416]">Partnership with HSCT team</li>
              <li className="text-[#3C2416]">
                Partnership with adult SCD program
              </li>
              <li className="text-[#3C2416]">
                Transfusion medicine specialist
              </li>
              <li className="text-[#3C2416]">Neuropsychologist</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  )
}

export default PediatricCenterCriteria
